import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { FormControl } from '@angular/forms';

import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { YearMonth } from '../../model/period.model';
import { Subscription } from 'rxjs';
import { TranslocoLocaleService } from '@ngneat/transloco-locale';
import { DateAdapter } from '@angular/material/core';

const moment = _rollupMoment || _moment;

@Component({
  selector: 'app-period-selector',
  templateUrl: './period-selector.component.html',
  styleUrls: ['./period-selector.component.scss']
})
export class PeriodSelectorComponent implements OnDestroy {

  rawStartYearMonth = '2022-01';
  _startYearMonth = moment(this.rawStartYearMonth);
  @Input() minDate?: Date;
  @Input() maxDate?: Date;

  @Input() set startYearMonth(value: string) {
    const temp = moment(value);
    this._startYearMonth.set('year', temp.year());
    this._startYearMonth.set('month', temp.month());
    this.startDateControl.patchValue(this._startYearMonth);
    this.rawStartYearMonth = value;
  }

  rawEndYearMonth = '2022-12';
  _endYearMonth = moment(this.rawEndYearMonth);
  @Input() set endYearMonth(value: string) {
    const temp = moment(value);
    this._endYearMonth.set('year', temp.year());
    this._endYearMonth.set('month', temp.month());
    this.endDateControl.patchValue(this._endYearMonth);
    this.rawEndYearMonth = value;
  }

  @Output() startYearMonthChange = new EventEmitter<YearMonth>();
  @Output() endYearMonthChange = new EventEmitter<YearMonth>();

  locale = 'en';
  startDateControl = new FormControl<Moment>(this._startYearMonth);
  endDateControl = new FormControl<Moment>(this._endYearMonth);
  localeSubscription: Subscription | undefined = undefined;

  constructor(
    private localeService: TranslocoLocaleService,
    private dateAdapter: DateAdapter<Moment>
  ) {
    this.localeSubscription = this.localeService.localeChanges$.subscribe(locale => {
      this.locale = locale;
      this.dateAdapter.setLocale(locale);
    });
  }

  ngOnDestroy(): void {
    this.localeSubscription?.unsubscribe();
  }

  setStartDate(normalizedMonthAndYear: Moment, datePicker: MatDatepicker<any>) {
    datePicker.select(normalizedMonthAndYear);
    datePicker.close();
    const startYearMonth: YearMonth = {
      year: this.startDateControl.value!.year(),
      month: this.startDateControl.value!.month()
    }
    this.startYearMonthChange.emit(startYearMonth);
  }

  setEndDate(normalizedMonthAndYear: Moment, datePicker: MatDatepicker<any>) {
    datePicker.select(normalizedMonthAndYear);
    datePicker.close();
    const endYearMonth: YearMonth = {
      year: this.endDateControl.value!.year(),
      month: this.endDateControl.value!.month()
    }
    this.endYearMonthChange.emit(endYearMonth);
  }
}
